import { Info } from "lucide-react";
import React, { FC } from "react";

interface InfoBoxProps {
  message: string;
}

const InfoBox: FC<InfoBoxProps> = ({ message }) => (
  <div className="flex bg-[rgb(255,248,245)] rounded-md border-l-4 border-[#ff7a3d] p-2 border border-[#ff7a3d]">
    <Info
      size={8}
      className="w-10 mt-2 h-3 text-xs font-medium rounded cursor-pointer text-[#ff7a3d] px-0.5"
    />

    <p className="text-xs text-primaryText leading-normal m-0 p-1">{message}</p>
  </div>
);

export default InfoBox;
